import React, { Component } from 'react';
import { connect } from 'react-redux';

import OrderModel from '../../../../models/PickupOrder';
import User from '../../../../models/User';

import { handlePrintPickupOrder } from '../../../../utils/printing';

import CommonOrderButtons from './CommonOrderButtons';

interface OrderButtonsContainerProps {
  user: User;
  order: OrderModel;
  secretKey?: string;
};


class OrderButtonsContainer extends Component<OrderButtonsContainerProps> {

  printPickupOrder = (): void => {

    const order: OrderModel = this.props.order;
    const secret: string | undefined = this.props.user.roleId !== 0 ? undefined : this.props.secretKey;

    if (order && order.number) {
      handlePrintPickupOrder(order.number, secret);
    }
  }

  render() {
    return (
      <CommonOrderButtons
        printPickupOrder={ this.printPickupOrder }
      />
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(OrderButtonsContainer);